import React from 'react';
import { useCalculator } from '../context/CalculatorContext';

const StatisticalSettings: React.FC = () => {
  const { 
    formState, 
    showStdDev, 
    handleInputChange,
    toggleLogTransformation
  } = useCalculator();

  return (
    <div className="p-4 bg-gray-50 dark:bg-gray-700/30 rounded-lg space-y-6">
      <h3 className="font-medium">Fine-tune Statistical Settings</h3>
      
      {/* Statistical Parameters */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label htmlFor="confidenceLevel" className="block text-sm font-medium mb-2">
            Confidence Level
          </label>
          <select
            id="confidenceLevel"
            name="confidenceLevel"
            value={formState.confidenceLevel}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
          >
            <option value="90">90%</option>
            <option value="95">95%</option>
            <option value="99">99%</option>
          </select>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Statistical certainty that results reflect a real effect rather than random chance
          </p>
        </div>
        <div>
          <label htmlFor="power" className="block text-sm font-medium mb-2">
            Statistical Power
          </label>
          <select
            id="power"
            name="power"
            value={formState.power}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
          >
            <option value="80">80%</option>
            <option value="85">85%</option>
            <option value="90">90%</option>
            <option value="95">95%</option>
          </select>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            Probability of detecting an effect if it truly exists
          </p>
        </div>
      </div>
      
      {/* Log Transformation Toggle (only for metric tests) */}
      {showStdDev && (
        <div className="py-2">
          <div className="flex items-start justify-between gap-4">
            <div className="flex-grow">
              <label htmlFor="logTransformation" className="block text-sm font-medium">
                Apply Log Transformation for Right-Skewed Data
              </label>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 pr-4">
                Transforms right-skewed distributions to approximate statistical normality assumptions. For highly skewed data, consider manual transformation of your raw data instead.
              </p>
            </div>
            <div className="flex-shrink-0 mt-1">
              <button
                type="button"
                id="logTransformation"
                onClick={toggleLogTransformation}
                className={`${
                  formState.logTransformation ? 'bg-blue-600' : 'bg-gray-200 dark:bg-gray-700'
                } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
              >
                <span className="sr-only">Apply log transformation</span>
                <span
                  className={`${
                    formState.logTransformation ? 'translate-x-6' : 'translate-x-1'
                  } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
                />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatisticalSettings;
